import { storiesOf } from '@storybook/react-native';
import { Img } from 'pawtner-mobile-ui';
import React from 'react';
import CenterView from './CenterView';

storiesOf('Img', module)
  .addDecorator((getStory) => <CenterView>{getStory()}</CenterView>)
  .add('Network image', () => (
    <Img
      cacheKey='test'
      width={200}
      height={200}
      uri='https://images.unsplash.com/photo-1600211906168-fbc6df476b1c?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwzfHx8ZW58MHx8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
    />
  ))
  .add('Local image', () => (
    <Img
      cacheKey='local-image'
      width={200}
      height={200}
      source={require('../../assets/favicon.png')}
    />
  ))
  .add('With border radius', () => (
    <Img
      cacheKey='border-radius'
      width={200}
      height={200}
      containerStyle={{ borderRadius: 20 }}
      uri='https://images.unsplash.com/photo-1600211906168-fbc6df476b1c?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwzfHx8ZW58MHx8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
    />
  ))
  .add('Loading image', () => (
    <Img
      cacheKey='loading-image'
      width={200}
      height={200}
      containerStyle={{ borderRadius: 20 }}
      uri='a'
    />
  ));
